module.exports = __webpack_public_path__ + "static/media/ru.e2037a0e.svg";